import Info from '../services/info';

let wxAuth;
function wxConfig() {
  const { wx } = window;
  const baseUrl = `${process.env.VUE_APP_BASE_URL}home?t=${+new Date()}`
  console.log('baseUrl==>', baseUrl)
  wx.ready(() => {
    console.log('wx ready');
    // const url = `${window.location.href.split('#/')[0]}#/home`;
    wx.updateTimelineShareData({
      title: '救命！世界杯和考试撞了……',
      link: baseUrl,
      imgUrl: 'https://ydlunacommon-cdn.nosdn.127.net/999c62b5ceea3854d94f26056ec72fbe.jpg',
      success() {
        // 设置成功
        console.log('wx ready');
      },
      fail: (res) => {
        console.log(' error ==', res);
        if (res.errMsg.indexOf('function_not_exist') > 0) {
          console('版本过低请升级');
        }
      },
    });
    wx.onMenuShareAppMessage({
      title: '救命！世界杯和考试撞了……',
      link: baseUrl,
      desc: '看书还是看球？这是个好问题！',
      imgUrl: 'https://ydlunacommon-cdn.nosdn.127.net/999c62b5ceea3854d94f26056ec72fbe.jpg', // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果 type 是music或video，则要提供数据链接，默认为空
      success() {
        // 用户点击了分享后执行的回调函数
      },
    });
    wx.updateAppMessageShareData({
      title: '救命！世界杯和考试撞了……',
      link: baseUrl,
      desc: '看书还是看球？这是个好问题！',
      imgUrl: 'https://ydlunacommon-cdn.nosdn.127.net/999c62b5ceea3854d94f26056ec72fbe.jpg',
      success() {
        // 设置成功
      },
    });
    wx.onMenuShareTimeline({
      title: '救命！世界杯和考试撞了……',
      link: baseUrl,
      imgUrl: 'https://ydlunacommon-cdn.nosdn.127.net/999c62b5ceea3854d94f26056ec72fbe.jpg',
      success() {
        // 用户点击了分享后执行的回调函数
      },
    });
  });
  wx.error((res) => {
    console.log('wx error===', res);
  });
  wx.config({
    debug: false,
    appId: wxAuth.appId,
    timestamp: wxAuth.timestamp,
    nonceStr: wxAuth.nonceStr,
    signature: wxAuth.signature,
    jsApiList: [
      'updateTimelineShareData',
      'updateAppMessageShareData',
      'onMenuShareAppMessage',
      'onMenuShareTimeline',
    ],
  });
}

function initWX() {
  const ua = window.navigator.userAgent.toLowerCase();
  if (!/micromessenger/i.test(ua)) {
    return
  }
  Info.getWinxinInfo({
    url: window.location.href.split('#/')[0],
  }).then((res) => {
    wxAuth = res;
    wxConfig();
  });
}

export default {
  initWX,
  wxAuth,
}
